module.exports = {
    WS_ENDPOINT : 'https://server.torrz.in'
}